import { getFunctions, httpsCallable } from 'firebase/functions';
import app from './config';

const fns = getFunctions(app, 'us-central1');

export const callLookupUserByEmail = (email) =>
  httpsCallable(fns, 'lookupUserByEmail')({ email }).then((r) => r.data);

export const callLookupCompanyOfUser = (uid) =>
  httpsCallable(fns, 'lookupCompanyOfUser')({ uid }).then((r) => r.data);

export const callSendPushToUser = (uid, title, body, data = {}) =>
  httpsCallable(fns, 'sendPushToUser')({ uid, title, body, data });

// Server-side PDF generation (invoices and account statements). Returns
// { url, path, name } of the PDF the function rendered and filed in the horse's
// documents. docType is 'Invoice' (default) or 'Statement'.
// `horseIds` bills one invoice to several horses: the PDF is rendered once and
// filed in each of their Documents. Omit it for an ordinary one-horse invoice.
// `pay` = { invoiceNumber } asks the server to add a "Pay online" link when the
// provider has finished Stripe setup (it's silently left off otherwise).
export const callGenerateInvoice = (horseId, html, fileName, docType = 'Invoice', horseIds = null, pay = null) =>
  httpsCallable(fns, 'generateInvoice', { timeout: 120000 })({
    horseId, html, fileName, docType, horseIds,
    ...(pay ? { offerOnlinePay: true, invoiceNumber: pay.invoiceNumber || '' } : {}),
    ...(pay && pay.emailTo ? { emailTo: pay.emailTo, emailTotal: pay.emailTotal || 0, clientName: pay.clientName || '' } : {}),
  }).then((r) => r.data);

// Online payments (Stripe). Status: { connected, ready, bank }. Connect returns
// { url } — Stripe's hosted setup page for this provider's business.
export const callLedgerPayLink = (horseId, companyKey) =>
  httpsCallable(fns, 'ledgerPayLink')({ horseId, companyKey }).then((r) => r.data);
export const callStripeSetFeePolicy = (clientPays) =>
  httpsCallable(fns, 'stripeSetFeePolicy')({ clientPays: !!clientPays }).then((r) => r.data);
export const callStripeRefundPayment = (entryId, cancelCharges = true) =>
  httpsCallable(fns, 'stripeRefundPayment')({ entryId, cancelCharges }).then((r) => r.data);
export const callSendPaymentReminder = (args) =>
  httpsCallable(fns, 'sendPaymentReminder', { timeout: 60000 })(args).then((r) => r.data);
export const callStripeRestoreRefundedCharges = (entryId) =>
  httpsCallable(fns, 'stripeRestoreRefundedCharges')({ entryId }).then((r) => r.data);
export const callStripeTestDisputeOutcome = (entryId, outcome) =>
  httpsCallable(fns, 'stripeTestDisputeOutcome')({ entryId, outcome }).then((r) => r.data);
export const callAdminClearSandboxPayments = () =>
  httpsCallable(fns, 'adminClearSandboxPayments', { timeout: 300000 })({}).then((r) => r.data);
export const callAdminListFeeRates = () =>
  httpsCallable(fns, 'adminListFeeRates')({}).then((r) => r.data);
export const callAdminSetFeeRate = (args) =>
  httpsCallable(fns, 'adminSetFeeRate')(args).then((r) => r.data);
export const callAnnounceOnlinePayments = () =>
  httpsCallable(fns, 'announceOnlinePayments', { timeout: 300000 })({}).then((r) => r.data);
export const callStripeStatus = () =>
  httpsCallable(fns, 'stripeStatus')({}).then((r) => r.data);
export const callStripeConnect = (restart = false, acceptFees = false) =>
  httpsCallable(fns, 'stripeConnect')({ ...(restart ? { restart: true } : {}), ...(acceptFees ? { acceptFees: true } : {}) }).then((r) => r.data);
export const callStripeAcceptFees = () =>
  httpsCallable(fns, 'stripeAcceptFees')({}).then((r) => r.data);
export const callStripePaymentFees = (entryId) =>
  httpsCallable(fns, 'stripePaymentFees')({ entryId }).then((r) => r.data);

// Deletes the signed-in user's data and then their login, server-side (see
// deleteMyAccount in functions/index.js for exactly what is removed and kept).
export const callDeleteMyAccount = () =>
  httpsCallable(fns, 'deleteMyAccount', { timeout: 300000 })({}).then((r) => r.data);
